import React from 'react'

export const Tick = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width={10} height={8} fill='none'>
    <path
      fill='#fff'
      fillRule='evenodd'
      d='M9.678 1.909 3.661 7.55.311 4.41 1.678 2.95l1.983 1.859L8.311.45l1.367 1.459Z'
      clipRule='evenodd'
    />
  </svg>
)
